import React from "react";
import styles from "./ChatArea.module.scss";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Add, Info } from "@mui/icons-material";

const ChatAreaInputAccountBtn = ({
  onClick,
  disabled = false,
}: {
  onClick: () => void;
  disabled?: boolean;
}) => {
  return (
    <IconButton
      size="small"
      className={`${styles.addCustomerInfoButton} ${disabled ? styles.addCustomerInfoButtonDisabled : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      <Add
        fontSize="inherit"
        style={{ fontSize: "14px" }}
      />
      <span className={styles.addCustomerInfo}>Customer Info</span>
      <Tooltip
        title={
          <Box className={styles.tooltipContent}>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, mb: 1 }}
            >
              Add account information to enhance AI responses
            </Typography>
            <Typography
              variant="caption"
              sx={{ display: "block", mb: 0.5 }}
            >
              Available data options:
            </Typography>
            <Box
              component="ul"
              sx={{ m: 0, pl: 2, fontSize: "12px" }}
            >
              <li>Account Details - Basic account information</li>
              <li>
                Subscription Details - Subscription, sku, site and risk assessments related info.
              </li>
              <li>Success Plan Details - Customer success planning info</li>
              <li>Recent Activities - Latest account activities</li>
              <li>Technical Support Cases - Support case history</li>
              <li>Webex Meeting Usage - Meeting usage analytics</li>
              <li>Webex Calling Usage - Calling usage statistics</li>
              <li>Webex Messaging Usage - Messaging usage data</li>
            </Box>
          </Box>
        }
        arrow
        placement="top"
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: "#ffffff",
              border: "1px solid #d1d5db",
              boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
              maxWidth: "none",
            },
          },
          arrow: {
            sx: {
              color: "#ffffff",
              "&::before": {
                border: "1px solid #d1d5db",
              },
            },
          },
        }}
      >
        <Info
          color="inherit"
          className={styles.infoIcon}
        />
      </Tooltip>
    </IconButton>
  );
};

export default ChatAreaInputAccountBtn;
